module.exports = __webpack_public_path__ + "img/T715.0bf586ba.jpg";